export function mutationDuringEventDelivery() {
    return {
        ok: false,
        error: { code: "transaction-failed", message: "Cannot mutate during domain event delivery" },
    };
}
//# sourceMappingURL=failures.js.map